import ModuleExplanationPanel from './ModuleExplanationPanel'
import { MODULE_REGISTRY } from '../lib/quantityEngine'

// =======================================================================
// DedicatedModuleWrapper — the ONE place that renders "How This Is
// Calculated" + "Glossary" for ANY dedicated engineering module. This
// makes the explanation section structurally IMPOSSIBLE to omit — a
// module panel never calls ModuleExplanationPanel itself; it only
// supplies content (via MODULE_REGISTRY[moduleKey].explanation), and
// this wrapper controls layout/placement/behaviour for every module,
// current and future.
//
// Enforcement: a registered dedicated module with missing/incomplete
// explanation content must NEVER silently render nothing — that hides
// a real registration mistake instead of surfacing it. This reusable
// check applies to every module through this one wrapper.
// =======================================================================

function validateExplanationContract(moduleKey, moduleDef) {
  const missing = []
  if (!moduleDef) return [`Module "${moduleKey}" is not registered in MODULE_REGISTRY at all.`]
  if (!moduleDef.explanation) missing.push('explanation')
  else {
    if (!moduleDef.explanation.method) missing.push('explanation.method')
    if (!moduleDef.explanation.inputSources?.length) missing.push('explanation.inputSources')
    if (!moduleDef.explanation.glossary?.length) missing.push('explanation.glossary')
  }
  return missing
}

export default function DedicatedModuleWrapper({ moduleKey, children }) {
  const moduleDef = MODULE_REGISTRY[moduleKey]
  const missing = validateExplanationContract(moduleKey, moduleDef)

  return (
    <div>
      {missing.length > 0 && (
        <div style={{ padding: '8px 10px', background: '#FEE2E2', border: '1px solid #DC2626', borderRadius: 6, marginBottom: 10, fontSize: 11, color: '#991B1B', fontWeight: 700 }}>
          ⚠ DEVELOPER WARNING: Module "{moduleKey}" is missing required explanation content: {missing.join(', ')}. This module does not meet the mandatory Breakdown/Explanation contract and must not be considered complete.
        </div>
      )}
      <ModuleExplanationPanel explanation={moduleDef?.explanation} />
      {children}
    </div>
  )
}
